import * as buyingPowerCalculatorForm from 'login-utils/buyingPowerCalculatorForm';
import baseRequest from './baseRequest';

// istanbul ignore next
export async function getBuyingPower(values: buyingPowerCalculatorForm.FIELDS): Promise<BuyingPowerFields> {
  return (await baseRequest.post('/api/login-ui/buying-power-calculator', values)).data;
}

export async function emitPartyApplicationAccessEvent(loanId: string): Promise<void> {
  await baseRequest.post(`/api/login-ui/party-application-access/${loanId}`);
}
